export default __webpack_public_path__ + "static/media/flower3.86320a38.jpg";